import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el contenedor punteado que
// aloja la previsualización de imagen (`ImagePreviewBox`) era el mismo
// marcado palabra por palabra en rewards/RewardsScreen.tsx y
// offers/OffersScreen.tsx. El resto del contenido (descripción + Reemplazar
// en Recompensas, input directo en Ofertas) sigue siendo propio de cada
// pantalla, vía `children`. Extracción sin cambio de comportamiento ni de
// valores visuales: ninguna pantalla que la use cambia un pixel por esto.
export function ImageUploadBox({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 14,
        padding: 12,
        border: `1px dashed ${tokens.surface.line2}`,
        borderRadius: 12,
      }}
    >
      {children}
    </div>
  );
}
